import { Typography } from '@/shared/components/ui/typography'
import { cn } from '@/shared/lib/utils'
import { ComponentProps } from 'react'

export function LearningRecommendationsPageHeader(
  props: ComponentProps<'header'>
) {
  return (
    <header
      {...props}
      className={cn(
        'bg-position-[120px,120px] relative flex items-center justify-between gap-2 rounded-xl bg-plan-bg bg-cover px-3 py-6 md:px-6 md:py-8',
        props.className
      )}
      style={{
        backgroundPositionY: '35%',
      }}
    >
      <div className="flex max-w-prose flex-col gap-2 md:p-6">
        <Typography variant="h2" className="font-semibold">
          Your Next Level, Curated for You
        </Typography>
        <Typography variant="subtitle">
          Each course is chosen to strengthen your capacity to execute, lead,
          and perform as an AI-native professional.
        </Typography>
      </div>
      <div className="hidden w-[395px] flex-shrink-0 md:block">
        <img
          src="/images/top-10.png"
          className="absolute bottom-0 right-0 h-[196px] max-h-full w-[395px]"
        />
      </div>
    </header>
  )
}
